<app-navbar areaButtonText="Ir a calibración, calificación y ensayo" areaButtonLink="/calibraciones"></app-navbar>
<router-outlet></router-outlet>
<app-footer [showEmailSubs]="false"></app-footer>